jQuery(document).ready(function($) {
    if (!window.WebAssessmentCharts) {
        window.WebAssessmentCharts = {}; // Create namespace if it doesn't exist
    }	
	var charts = {};
	let projectID;
	if ($('body').hasClass('single-projects')) {
		// Extract the URL path and split it to get the slug
		const pathParts = window.location.pathname.split('/projects/');
		if (pathParts.length > 1) {
			// Get the slug portion after '/projects/' and remove any trailing slash if present
			projectID = pathParts[1].split('/')[0];
		}
	}
	
	console.log('Extracted projectID:', projectID); // Verify the extracted project ID
	
	// Now using utility function from fetchProjectChartData.js
	WebAssessmentCharts.fetchProjectChartData = fetchProjectChartData;
	var homeFrameworkProcessUniqueItems = processUniqueItemsCIS;

	// Fetch project data and CRF data, then process them together
	WebAssessmentCharts.fetchDataAndCalculateScores = async function(projectID) {
		console.log('[nycrr20.js] fetchDataAndCalculateScores triggered for projectID:', projectID);
		// Extract the URL path and split it to get the slug
		const pathParts = window.location.pathname.split('/projects/');
		if (pathParts.length > 1) {
			// Get the slug portion after '/projects/' and remove any trailing slash if present
			projectID = pathParts[1].split('/')[0];
		}
		
		try {
			// Fetch project data
			const projectData = await WebAssessmentCharts.fetchProjectChartData(projectID);
			
			// Check if project data is valid
			if (!projectData || !Array.isArray(projectData)) {
				console.error('Project data is missing or not structured as expected:', projectData);
				return;
			}
			
			const projectItems = projectData;
			const processedItems = homeFrameworkProcessUniqueItems(projectItems);
			console.log('processedItems:', processedItems);
			
			// Fetch NYCRR standards data directly
			try {
				const response = await jQuery.ajax({
					url: controlsData.ajax_url,
					type: 'POST',
					dataType: 'json',
					data: {
						action: 'api_action',
						year: '2024',
						apis: ['CS'],
						CSLstandardID: 'NYCRR-500-2-0'
					}
				});

				console.log('NYCRR Standards response structure:', JSON.stringify(response, null, 2));
				// Store the response for use by other functions
				WebAssessmentCharts.nycrr500Data = response;

				if (!response.CS || !response.CS.Items) {
					console.error('Invalid NYCRR standards response structure:', response);
					return;
				}
				
				// Now run the NYCRR20 function with the enhanced data
				WebAssessmentCharts.NYCRR20(processedItems, response);
			}
			catch (error) {
				console.error('Error fetching NYCRR standards:', error);
				// If we fail to get standards data, we can still try to show the NYCRR chart with the data we have
				WebAssessmentCharts.NYCRR20(processedItems);
			}
			
			$('.modal-body .loader').hide();
			
		} catch (error) {
			console.error('Error processing data:', error);
			$('.modal-body .loader').hide();
		}
	}

	if (typeof WebAssessmentCharts.registerHomeDashboardFetcher === 'function') {
		WebAssessmentCharts.registerHomeDashboardFetcher('nycrr-500-v2', WebAssessmentCharts.fetchDataAndCalculateScores);
	}
	
	// Now using utility function from calculateMaturityScore.js
	WebAssessmentCharts.calculateMaturityScore = calculateMaturityScore;
	
	// Now using utility function from getMostRecentSafeguards.js
	WebAssessmentCharts.getMostRecentSafeguards = getMostRecentSafeguards;
	
	// Now using utility function from processUniqueItemsCIS.js
	WebAssessmentCharts.processUniqueItems = processUniqueItemsCIS;
	
	WebAssessmentCharts.calculateNYCRRCategoryAverages = function(items, nycrr500Data) {
		const categoryScores = {};
		const categoryPotentialCounts = {};
		
		// First gather potential counts from NYCRR 500 data if available
		if (nycrr500Data && nycrr500Data.CS && nycrr500Data.CS.Items) {
			nycrr500Data.CS.Items.forEach(control => {
				if (control.controlid && control.controlid.S) {
					const safeguardId = control.controlid.S;
					// Match pattern like "500.2" or "500.2.a"
					const match = safeguardId.match(/^500\.(\d+)/);
					
					if (match) {
						const category = match[1]; // Extract the main number (e.g. 2, 3, etc)
						
						if (!categoryPotentialCounts[category]) {
							categoryPotentialCounts[category] = 0;
						}
						categoryPotentialCounts[category]++;
					}
				}
			});
		}
		console.log("NYCRR Category potential counts: ", categoryPotentialCounts);
		
		// Initialize category scores structure with potential counts
		Object.keys(categoryPotentialCounts).forEach(category => {
			categoryScores[category] = { 
				total: 0,
				totalItems: 0,
				notApplicableCount: 0,  // Count of items with policystatus 1
				potentialCount: categoryPotentialCounts[category]
			};
		});

		// Process actual scores from items
		items.forEach(item => {
			const safeguardId = item.safeguardid.S;
			// Match pattern like "500.2" or "500.2.a"
			const match = safeguardId.match(/^500\.(\d+)/);
			
			if (match) {
				const category = match[1]; // Extract the main number (e.g. 2, 3, etc)
				const policystatus = parseInt(item.policystatus.N, 10);
				const maturityScore = WebAssessmentCharts.calculateMaturityScore(policystatus);

				if (!categoryScores[category]) {
					categoryScores[category] = { 
						total: 0,
						totalItems: 0,
						notApplicableCount: 0,
						potentialCount: categoryPotentialCounts[category] || 0
					};
				}

				categoryScores[category].totalItems++;

				if (maturityScore === null) {
					// Not Applicable items (policystatus 1)
					categoryScores[category].notApplicableCount++;
				} else {
					// Add the score (will be 0 for unanswered questions)
					categoryScores[category].total += maturityScore;
				}
			}
		});

		// Calculate averages
		const averages = {};
		Object.keys(categoryScores).forEach(category => {
			const { total, totalItems, notApplicableCount, potentialCount } = categoryScores[category];
			
			// If all items in category are marked as "Not Applicable", set average to null
			if (notApplicableCount === totalItems && totalItems > 0) {
				averages[category] = null;
			} else {
				// Calculate denominator: total items minus Not Applicable items
				const applicableItems = totalItems - notApplicableCount;
				const denominator = applicableItems > 0 ? applicableItems : potentialCount;
				averages[category] = denominator > 0 ? total / denominator : 0;
				console.log(`Category ${category}: total=${total}, totalItems=${totalItems}, notApplicableCount=${notApplicableCount}, applicableItems=${applicableItems}, potentialCount=${potentialCount}, denominator=${denominator}, average=${averages[category]}`);
			}
		});

		console.log("NYCRR Category averages: ", averages);
		return averages;
	}
	
	WebAssessmentCharts.NYCRR20 = function(items, nycrr500Data) {
		console.log('Starting NYCRR 500 v2 function...');
		const tableBody = document.querySelector('#nycrr500 tbody');
		if (!tableBody) {
			console.error('NYCRR 500 v2 table body not found.');
			return;
		}

		// Store original row indices before any modifications
		const originalIndices = new Map();
		Array.from(tableBody.rows).forEach((row, index) => {
			originalIndices.set(row, index);
		});
	
		// Define a mapping of table row labels to safeguard keys
		const categoryKeyMap = {
			"Cybersecurity Program": "500.2",
			"Cybersecurity Policy": "500.3",
			"Cybersecurity Governance": "500.4",
			"Vulnerability Management": "500.5",
			"Audit Trail": "500.6",
			"Access Privileges and Management": "500.7",
			"Application Security": "500.8",
			"Risk Assessment": "500.9",
			"Cybersecurity Personnel and Intelligence": "500.10",
			"Third-Party Service Provider Security Policy": "500.11",
			"Multi-Factor Authentication": "500.12",
			"Asset Management and Data Retention Requirements": "500.13",
			"Monitoring and Training": "500.14",
			"Encryption of Nonpublic Information": "500.15",
			"Incident Response and Business Continuity Management": "500.16",
			"Notices to Superintendent": "500.17"
		};

		// Create a map of all possible safeguards from the standard
		const allSafeguards = new Map();
		if (nycrr500Data && nycrr500Data.CS && nycrr500Data.CS.Items) {
			nycrr500Data.CS.Items.forEach(control => {
				if (control.controlid && control.controlid.S) {
					allSafeguards.set(control.controlid.S, {
						safeguardid: { S: control.controlid.S },
						policystatus: { N: "0" }, // Default to "Not Answered"
						maturityscore: 0 // Default score for unanswered items
					});
				}
			});
		}

		// Merge in any existing answers
		const processedItems = homeFrameworkProcessUniqueItems(items);
		processedItems.forEach(item => {
			allSafeguards.set(item.safeguardid.S, item);
		});

		// Convert back to array
		const mergedItems = Array.from(allSafeguards.values());
		console.log('Merged items (including unanswered):', mergedItems);

		// Calculate averages by category
		const averageScores = WebAssessmentCharts.calculateNYCRRCategoryAverages(mergedItems, nycrr500Data);
	
		// Keep track of rows to remove
		const rowsToRemove = [];

		// Make all rows visible first
		Array.from(tableBody.rows).forEach(row => {
			row.style.display = '';
		});
	
		// Update the table rows based on the mapping
		Array.from(tableBody.rows).forEach((row) => {
			const categoryLabel = row.cells[0].textContent.trim();
			const baseKey = categoryKeyMap[categoryLabel];
		
			if (!baseKey) {
				console.warn(`No safeguard key found for category: ${categoryLabel}`);
				return;
			}
		
			// Get the category number from the baseKey (e.g., "2" from "500.2")
			const category = baseKey.split('.')[1];
		
			if (averageScores[category] !== undefined) {
				if (averageScores[category] === null) {
					// Only remove rows that are explicitly marked as not applicable
					// (all items in the category have policy status 1)
					rowsToRemove.push(row);
				} else {
					const averageScore = averageScores[category] * 5; // Scale to 0-5
					row.cells[1].textContent = averageScore.toFixed(2);
					console.log(`Updated ${categoryLabel} with average score:`, averageScore.toFixed(2));
				}
			} else {
				row.cells[1].textContent = "0.00";
				console.warn(`No data found for category: ${categoryLabel}`);
			}
		});
	
		// Remove rows with all null values (all items are Not Applicable)
		rowsToRemove.forEach(row => {
			row.remove();
		});
	
		// Calculate and update overall maturity score
		let totalScore = 0;
		let scoreCount = 0;
		Array.from(tableBody.rows).forEach((row) => {
			const scoreText = row.cells[1].textContent;
			const score = parseFloat(scoreText);
			if (!isNaN(score)) {
				totalScore += score;
				scoreCount++;
			}
		});
	
		const maturityRatingRow = document.querySelector('#nycrr500 tfoot .light-background td');
		if (maturityRatingRow && scoreCount > 0) {
			const overallMaturity = totalScore / scoreCount;
			WebAssessmentCharts.overallNYCRR5002maturity = overallMaturity;
			maturityRatingRow.textContent = overallMaturity.toFixed(2);
			$('.audit-overall-value').text(overallMaturity.toFixed(2));
			$('.nycrr-overall-value').text(overallMaturity.toFixed(2));
			console.log(`Updated NYCRR overall maturity rating to ${overallMaturity.toFixed(2)}`);
		} else {
			console.error("Error: No scores found or maturity rating row not found in the table.");
		}
	
		// Show the NYCRR container and create a chart
		applyFrameworkPanelVisibility('show', '.nycrr500-container');
		WebAssessmentCharts.createChartFromTable('nycrr500', 'nycrr500-chart', charts, true);

		// Restore original row indices after chart creation
		rowsToRemove.forEach(row => {
			const originalIndex = originalIndices.get(row);
			if (originalIndex !== undefined) {
				tableBody.insertBefore(row, tableBody.rows[originalIndex] || null);
				row.style.display = 'none';
			}
		});
	};
	

	// Now using utility function from chartEventHandlers.js
	if ($('body').hasClass('single-projects')) {
		initializeChartEventHandlers();
	}
	
});